import getOcTheme from '../../../theme/services/getOcTheme';

import baseStyles from '../base';

const theme = getOcTheme();

const { typography } = theme;

export default {
  root: {
    ...baseStyles.root,
    ...typography.body2,
  },
};
